export default __webpack_public_path__ + "static/media/mobile-code.06ca1315.png";